import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Table, Card, Loader, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import EditIcon from '../icons/EditIcon';
import MailTable from '../common/mailTable';
import './styles.scss';

export const mailGroupcolumns = (props) => [
  {
    'Header': 'GRUPO',
    'accessor': 'mailGroup',
  },
  {
    'Header': 'DESCRIPCION',
    'accessor': 'description',
  },
  {
    'Header': 'ESTADO',
    'accessor': 'status',
  },
  {
    'id': 'actions',
    'Header': 'ACCIONES',
    'Cell': ({row}) => {
      const {mailGroup} = row.original;
      return (
        <EditIcon group={mailGroup} />
      );
    },
  },
];

class MailGroupList extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.MailGroups,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchMailGroupList();
  }

  renderLoaderOrMailGroup() {
    const {loading, mailGroupList} = this.props;
    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <MailTable
        list={mailGroupList}
        columnsTableWithProps={mailGroupcolumns}
      />
    );
  }

  render() {
    return (
      <div className="mail-group-list">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Mantenimiento Grupos de Correo</h2>
              <div className="title-bar-actions">
                <Button primary className="toyota-primary" as={Link} to={paths.MailGroupNew}>
                  Nuevo Grupo
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card fluid raised>
          {this.renderLoaderOrMailGroup()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.mailGroupList.loading,
    'mailGroupList': state.mailGroupList.list,
    'permissions': state.session.permissions,
  };
};

const {fetchMailGroupList, navigateTo} = Actions;

export default connect(mapStateToProps, {
  fetchMailGroupList,
  navigateTo,
})(MailGroupList);
